import type { SVGProps } from "react";
export default function SvgMove(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-move-icon lucide-move"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="M12 2v20" />
			<path d="m15 19-3 3-3-3" />
			<path d="m19 9 3 3-3 3" />
			<path d="M2 12h20" />
			<path d="m5 9-3 3 3 3" />
			<path d="m9 5 3-3 3 3" />
		</svg>
	);
}
